@let disabled = $disabled() !== undefined ? $disabled() : $controlDisabled();
@let readonly = $readonly();
@let controlPosition = $controlPosition();
@let verticalAlignment = $verticalAlignment() === 'center' ? 'items-center' : $verticalAlignment() === 'start' ? 'items-start' : 'items-end';
<label class="radio-label"
  [class]="(readonly ? '' : 'select-none ') + 'flex' + (controlPosition === 'default' || controlPosition === 'opposite' ? ' items-center' : ' flex-col ' + verticalAlignment)"
  [style.padding]="$innerPadding()"
  [style.gap]="$gap() | cssValue"
  [matTooltip]="!disabled ? $tooltip() : $tooltipWhenDisabled()"
>
  <input
    type="radio"
    [disabled]="disabled || readonly"
    [checked]="$value() === $controlValue()"
    [class.disab]="disabled"
    [class.readonly]="readonly"
    [class]="controlPosition === 'default' || controlPosition === 'top' ? 'order-0' : 'order-1'"
    [name]="$name()"
    [value]="$value()"
    (change)="onValueChange($event)"
  >
  @if ($label() !== null) {
  <p
    [class]="$labelWrap() ? '' : 'whitespace-nowrap'"
    [style.fontSize]="$labelFontSize() | cssValue"
    [style.fontWeight]="$labelWeight()"
    [style.color]="'var(' + $labelColor() + ')'"
  >{{ $label() }}</p>
  }
</label>
